<p-toast />
<div class="layout-centered">
  <p-card styleClass="card-style-account">
    <ng-template pTemplate="header">
      <img src="/assets/images/logo-redcurve.png" id="logo-redcurve" />
    </ng-template>

    <h1 class="h3">Forgot Password</h1>
    <p class="">Please enter the email associated with your RCS Account and we'll send you instructions to reset your password.</p>
    <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
      <div class="field mb-2">
        <label for="email">Email</label>
        <input pInputText id="email"
               formControlName="email"
               type="email" />
      </div>
      <div class="text-center mt-3">
        <button pButton type="submit" class="mt-2" label="Submit" [disabled]="forgotPasswordForm.invalid"></button>
      </div>
    </form>
  </p-card>

  <div class="centered-footer">
    <span>Copyright &copy; 2025</span> |
    <span>RedCurve Solutions &reg;</span> |
    <span>All Rights Reserved</span>
  </div>
</div>
